import "./index.scss";

import { Box, Modal, Stack } from "@mui/material";
import { ReactComponent as MemberIcon } from "assets/images/icons/member.svg";
import { ReactComponent as DeleteIcon } from "assets/images/square-buttons/close-small.svg";
import { ReactComponent as UncheckedCircleIcon } from "assets/images/toggle-checkboxes/circle/off-normal.svg";
import { ReactComponent as CheckedCircleIcon } from "assets/images/toggle-checkboxes/circle/on-normal.svg";
import Button from "components/Button";
import { MSG_OPERATION_FAILED, MSG_OPERATION_SUCCESSFUL } from "constants/index";
import { stringToColor } from "helpers/utils";
import { massInstructorSwitch, massReassignInstructor } from "modules/member/memberServices";
import { useState } from "react";
import { toast } from "react-toastify";

const MODULE_ENUMS = {
  memberTask: "member-task",
  staffDetailsAssignedMembers: "staff-details-assigned-members",
};

const MassInstructorSwitchModal = (props: {
  open: boolean;
  onClose: any;
  memberIds: number[];
  instructorOptions: any[];
  moduleName: string;
}) => {
  const { open, onClose, memberIds, instructorOptions, moduleName } = props;
  const [isPending, setIsPending] = useState(false);
  const [selectedInstructorId, setSelectedInstructorId] = useState();

  //#region event handlers
  const handleCloseModal = (isRefreshNeeded = false) => {
    if (isPending) return;
    onClose(isRefreshNeeded);
  };

  const handleConfirm = () => {
    if (!selectedInstructorId) {
      toast("Select an instructor", { type: "error" });
      return;
    }
    setIsPending(true);
    let req = null;
    if (moduleName === MODULE_ENUMS.memberTask) {
      req = massReassignInstructor;
    } else {
      req = massInstructorSwitch;
    }
    req({
      instructor_id: selectedInstructorId,
      members: memberIds,
    })
      .then((res) => {
        if (res.success) {
          toast(MSG_OPERATION_SUCCESSFUL, { type: "success" });
          handleCloseModal(true);
        }
      })
      .catch((e) => {
        console.log(e);
        toast(MSG_OPERATION_FAILED, { type: "error" });
      })
      .finally(() => setIsPending(false));
  };
  //#endregion event handlers

  return (
    <Modal
      closeAfterTransition
      BackdropProps={{
        timeout: 500,
      }}
      open={open}
      onClose={() => handleCloseModal(false)}
    >
      <Stack className="personal-details-modal-container mass-instructor-switch-container">
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="center"
          marginBottom="40px"
          className="header"
        >
          <h1>Instructor Switch ({memberIds.length} Members) </h1>
          <DeleteIcon width="24px" height="24px" onClick={() => handleCloseModal(false)} />
        </Stack>
        <Box className={`searchable-list-container`}>
          <Box className="list">
            {instructorOptions?.map((item, index) => (
              <button
                className={`checkable-button ${
                  item.instructor_id === selectedInstructorId ? `selected` : ``
                }`}
                key={`instructorOption${index}`}
                onClick={() => setSelectedInstructorId(item.instructor_id)}
              >
                <Stack direction={"row"} width={"100%"} gap={1}>
                  <Box>
                    <span
                      style={{
                        backgroundColor: stringToColor(item.label),
                      }}
                      className={"rounded-circle member-icon"}
                    >
                      <MemberIcon className="icon-white size16" />
                    </span>
                  </Box>
                  <Stack flexGrow={1} gap={"6px"}>
                    <Box className="memberName">{item.label}</Box>
                    <Stack
                      className="description"
                      direction={"row"}
                      width={"100%"}
                      justifyContent={"space-between"}
                    >
                      <Box>Staff</Box>
                      <Box>{item.members_count || 0} Members</Box>
                    </Stack>
                  </Stack>
                  <Box className="check">
                    <CheckedCircleIcon className="showOnHover" />
                    <UncheckedCircleIcon className="showOnMouseOut" />
                  </Box>
                </Stack>
              </button>
            ))}
          </Box>
        </Box>
        <Stack direction="row" alignItems="center" justifyContent="flex-end" marginTop="30px">
          <Stack direction="row" alignItems="center" spacing={3}>
            <Button
              type="button"
              label="Cancel"
              className="text-button"
              onClick={() => handleCloseModal(false)}
            />
            <Button
              type="button"
              label="Reassign"
              className="confirm-button"
              loading={isPending}
              onClick={handleConfirm}
            />
          </Stack>
        </Stack>
      </Stack>
    </Modal>
  );
};

export default MassInstructorSwitchModal;
